export const ORDER_LIST_COLUMN_WIDTHS = {
  id: '5rem',
  orderNoGroup: '12rem',
  status: '6rem',
  customer: '14rem',
  subject: '12rem',
  salesperson: '10rem',
  businessType: '12rem',
  rentalAddress: '14rem',
  rentalPeriod: '14rem',
  occupancyMode: '8rem',
  leaseAction: '8rem',
  note: '14rem',
  createdBy: '10rem',
  createdAt: '12rem',
  updatedAt: '12rem'
} as const
